import { useEffect, useState } from 'react'
import { dia } from '@joint/core'
import {
  fitLightFrame,
  frameAngle,
  frameVertices,
  rotateLightGeometry,
  snapshotVertices,
} from '../lib/lightFrameGeometry'
import styles from './PropertyEditor.module.css'

interface LightAngleControlProps {
  element: dia.Element
  onUpdate: (id: string, updates: { data: unknown }) => void
}

export default function LightAngleControl({ element, onUpdate }: LightAngleControlProps) {
  const readAngle = () =>
    element.get('data')?.geometryAngle ?? frameAngle(frameVertices(snapshotVertices(element.toJSON())))
  const [angle, setAngle] = useState<number>(readAngle)
  useEffect(() => {
    const sync = () =>
      setAngle(element.get('data')?.geometryAngle ?? frameAngle(frameVertices(snapshotVertices(element.toJSON()))))
    sync()
    element.on('change:data', sync)
    return () => {
      element.off('change:data', sync)
    }
  }, [element])

  return (
    <div className={styles.group}>
      <label className={styles.groupLabel} htmlFor="light-geometry-angle">
        조명 각도 (°)
      </label>
      <input
        id="light-geometry-angle"
        type="number"
        step="0.1"
        value={Math.round(angle * 100) / 100}
        className={styles.input}
        onChange={(event) => {
          if (!event.target.value) return
          const value = Number(event.target.value)
          if (!Number.isFinite(value)) return
          rotateLightGeometry(element, value)
          onUpdate(String(element.id), { data: element.get('data') })
        }}
      />
      <span className={styles.csvNote}>수평 0°, 수직 90° · 중심을 기준으로 회전</span>
      {element.get('data')?.isGroup && (
        <button
          type="button"
          className={styles.input}
          onClick={() => {
            fitLightFrame(element)
            onUpdate(String(element.id), { data: element.get('data') })
          }}
        >
          도면 선에 맞추기
        </button>
      )}
    </div>
  )
}
